import React from "react";
import { Outlet } from "react-router-dom";
import HeaderContainer from "./Header.container";
import MenuContainer from "./Menu.container";

const LayoutComponent = (props: any) => {
    const { needStandaloneMain, needNoMenu, hideHeader } = props;

    return (
        <>
            {needStandaloneMain || hideHeader ? null : <HeaderContainer />}
            <Outlet />
            {needStandaloneMain ? null : <MenuContainer needNoMenu={needNoMenu} />}
        </>
    )
};

export default LayoutComponent;